import {
  COLOR_DISABLED,
  COLOR_ELEVATION_01,
  COLOR_PLACEHOLDER,
  MOBILE_WIDTH,
} from "./../../config";
import styled from "styled-components";
import {
  COLOR_ELEVATION,
  COLOR_PRIMARY_BLACK,
  COLOR_PRIMARY_GREEN,
  GREEN_GRADIENT,
  spacing,
} from "../../styleConfig";

export const LoginPageContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginLogo = styled.div`
  background-image: url(/images/logo-bocchi.png);
  background-size: contain;
  width: 300px;
  height: 65px;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: ${spacing(-10)};
  margin-bottom: ${spacing(5)};
`;

export const LoginForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  margin-top: ${spacing(2)};
  align-items: center;
`;

export const WaterMark = styled.p`
  margin-top: ${spacing(5)};
  color: ${COLOR_PLACEHOLDER};
  font-weight: 200;
`;

export const LeftSide = styled.div`
  width: calc(100% - 400px);
  height: 100%;
  background-image: url(/images/background.jpg);
  filter: brightness(0.5);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;

export const RightSide = styled.div`
  width: 500px;
  background-color: ${COLOR_ELEVATION};
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 45px;
  position: relative;

  @media (max-width: ${MOBILE_WIDTH}) {
    max-width: 100%;
  }
`;

export const BocchiLogo = styled.div`
  width: 200px;
  height: 60px;
  background-image: url(/images/logo-bocchi.png);
  background-repeat: no-repeat;
  position: absolute;
  bottom: 15px;
  left: 35px;
  background-size: contain;
`;

export const SecondaryLink = styled.div`
  color: ${COLOR_PRIMARY_BLACK};
  font-size: 14px;
  border-bottom: 1px solid transparent;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    border-bottom: 1px solid ${COLOR_PRIMARY_GREEN};
    color: ${COLOR_PRIMARY_GREEN};
  }
`;

export const SecondaryLinksWrapper = styled.div`
  margin-top: ${spacing(5)};
  width: 100%;
  display: flex;
  gap: 15px;
  flex-direction: column;

  align-items: center;
`;

export const BottomBar = styled.div`
  ${GREEN_GRADIENT}
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 50px;

  @media (max-width: ${MOBILE_WIDTH}) {
    position: fixed;
    width: 100%;
    height: 50px;
    bottom: 0;
    left: 0;
  }
`;

export const BottomBarText = styled.p`
  color: white;
  width: 100%;
  text-align: center;
  font-size: 11px;
  font-weight: 400;
`;
